import React, { useEffect } from 'react';
import styles from './Tabs.module.css';
import { useColumnContextAPI } from '../context/GetAllColumnContext';
import { Tabs, Tab } from '@airbus/components-react';
function TabPanel(props) {
  const { children, tabValue, index, ...other } = props;
  if (!props) {
    return <></>;
  }

  return (
    <div
      role='tabpanel'
      hidden={tabValue !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={styles.tabPanel}
      {...other}
    >
      {tabValue === index && <>{children}</>}
    </div>
  );
}

export default function BasicTabs({ tabs }) {
  const [tabValue, setTabValue] = React.useState(0);
  const tabsContainerRef = React.useRef<HTMLDivElement>(null);
  const { tabMenu, updateRightTabMenuDetails, rightPanelTabMenu } = useColumnContextAPI();
  const scrollToTab = (selectedIndex: number) => {
    setTimeout(() => {
      const tabElements = tabsContainerRef.current?.querySelectorAll("li a[role='tab']");
      const selectedTab = tabElements?.[selectedIndex] as HTMLElement | undefined;
      selectedTab?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }, 10);
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    updateRightTabMenuDetails(newValue);
    scrollToTab(newValue);
  };

  useEffect(() => {
    if (tabMenu >= 0) {
      setTabValue(tabMenu);
      scrollToTab(tabMenu);
    }
  }, [tabMenu]);

  useEffect(() => {
    if (rightPanelTabMenu >= 0) {
      setTabValue(rightPanelTabMenu);
      scrollToTab(rightPanelTabMenu);
    }
  }, [rightPanelTabMenu]);

  return (
    <div ref={tabsContainerRef} className={styles.tabsContainer}>
      <Tabs
        value={tabValue}
        variant='container'
        scrollable
        onChange={handleChange}
        aria-label='basic tabs example'
        className={styles.tabsAlign}
      >
        {tabs.length &&
          tabs.map(({ label }) => (
            <Tab
              key={`label_${label.replace(/\s/g, '')}`}
              className={`fw-bold test_${label.replace(/\s/g, '')}`}
            >
              {label}
            </Tab>
          ))}
      </Tabs>
      {tabs.length &&
        tabs.map(({ Component: component, label }, i) => (
          <TabPanel tabValue={tabValue} index={i} key={`component_${label.replace(/\s/g, '')}`}>
            {component}
          </TabPanel>
        ))}
    </div>
  );
}
